import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretUpDown20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCaretUpDown20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.066 13.283a.75.75 0 0 0-1.06-1.06L10 15.228l-3.005-3.005a.75.75 0 1 0-1.061 1.06L9.47 16.82l.53.53.53-.53zM5.934 6.73a.75.75 0 1 0 1.06 1.06L10 4.785l3.005 3.005a.75.75 0 0 0 1.06-1.06L10.53 3.194l-.53-.53-.53.53z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretUpDown20);
